module.exports = __webpack_public_path__ + "img/special_kingOfTheHill.ae932175.png";